var map = {
	"./american-express.svg": "5c8a",
	"./bb.svg": "7a33",
	"./bradesco.svg": "cfa2",
	"./caixa.svg": "474e",
	"./default.svg": "b01c",
	"./diners-club.svg": "2262",
	"./discover.svg": "49a8",
	"./elo.svg": "aaae",
	"./hiper.svg": "9d48",
	"./hipercard.svg": "b4d3",
	"./jcb.svg": "fbf2",
	"./maestro.svg": "4290",
	"./mastercard.svg": "52d2",
	"./mp.svg": "54ee",
	"./next.svg": "db02",
	"./picpay.svg": "9f05",
	"./pix-icon.svg": "a5c7",
	"./pix.svg": "8d1a",
	"./unionpay.svg": "46df",
	"./visa.svg": "8f2d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b8c";